import { createAction } from 'redux-actions';
import { actionTypePrefix } from './constants';
export var initializeThread = createAction(actionTypePrefix + "/INITIALIZE", function (thread) { return thread; });
export var initializeThreadFromPapi = function (_a) {
    var hasMore = _a.hasMore, hasLess = _a.hasLess, thread = _a.thread, total = _a.total, canPostComment = _a.canPostComment, commentableItemid = _a.commentableItemid, commentableTypeid = _a.commentableTypeid, cursor = _a.cursor, prevCursor = _a.prevCursor;
    return initializeThread({
        commentableItemId: commentableItemid,
        commentableTypeId: commentableTypeid,
        hasMore: hasMore,
        hasLess: hasLess,
        items: thread,
        total: total,
        canPostComment: canPostComment,
        cursor: cursor || undefined,
        prevCursor: prevCursor || undefined,
    });
};
export var streamIdChanged = createAction(actionTypePrefix + "/STREAM_ID_CHANGED", function (config) { return config; });
export var changeOrder = createAction(actionTypePrefix + "/CHANGE_ORDER", function (streamId, order) {
    return { order: order, streamId: streamId };
});
export var threadUpdated = createAction(actionTypePrefix + "/THREAD_UPDATED", function (streamId, result) {
    return { streamId: streamId, result: result };
});
//# sourceMappingURL=actionCreators.js.map